import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemplateLayout = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7 1.7H3.3C2.41634 1.7 1.7 2.41634 1.7 3.3V10.7C1.7 11.5837 2.41634 12.3 3.3 12.3H10.7C11.5837 12.3 12.3 11.5837 12.3 10.7V3.3C12.3 2.41634 11.5837 1.7 10.7 1.7Z",
			stroke: "currentColor",
			strokeWidth: 1.3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.7 5H12.3",
			stroke: "currentColor",
			strokeWidth: 1.3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5V12.3",
			stroke: "currentColor",
			strokeWidth: 1.3
		})
	]
});
export default SvgTemplateLayout;
